import { AspectRatio, Box, Flex, Image, Link, Text } from '@chakra-ui/react';
import onfiRevolution from '../../../assets/image/home/news/onfiRevolution.png';
import benefitsOfTokenization from '../../../assets/image/home/news/benefitsOfTokenization.png';
import { useIsMobile } from '../../../hooks/useIsMobile';

const NEWS = [
  {
    image: onfiRevolution,
    title: 'The OnFi Revolution',
    content: 'OnFi, or On-Chain Finance, is the Web3 vertical most likely to attract institutional attention',
    link: 'https://d3xxyz.medium.com/the-onfi-revolution-bridging-the-gap-between-traditional-finance-and-blockchain-d36947a808c1'
  },
  {
    image: benefitsOfTokenization,
    title: 'The 5 Key Benefits of Tokenization in 2024',
    content:
      'Why 2024 will be the year of tokenization — What’s the Big Deal? Tokenization promises to be not only a buzzword, but the key concept driving the crypto world in 2024.',
    link: 'https://medium.com/prosperex-official/the-5-key-benefits-of-tokenization-in-2024-fcb71ee93400'
  }
];

const NewHomeNews = () => {
  const isMobile = useIsMobile();

  return (
    <Box
      width={'100%'}
      display={'flex'}
      flexDir={'column'}
      alignItems={'center'}
      color={'white'}
      gap={'30px'}
      position={'relative'}
      mt="95px">
      <Text
        textAlign={'center'}
        textTransform="uppercase"
        fontSize={isMobile ? '20px' : '48px'}
        fontWeight={400}
        lineHeight={1.2}
        fontFamily="Georgia">
        NEWEST
      </Text>

      <Flex gap="24px" width={'100%'} px={{ base: '10px', md: 0 }} flexWrap="wrap" justifyContent="center">
        {NEWS.map((item) => (
          <Link
            key={item.title}
            href={item.link}
            isExternal
            _hover={{ textDecoration: 'none' }}
            maxW={'570px'}
            flexGrow={1}>
            <Flex
              flexDir={['column', null, 'row']}
              width={'100%'}
              borderRadius={'8px'}
              bg="#151515"
              padding={'22px 11px'}
              gap={'16px'}
              h="full"
              fontFamily={'Manrope'}
              rounded="28px">
              <AspectRatio
                mx="auto"
                maxW={{ base: '100%', md: '280px' }}
                width={'100%'}
                overflow={'hidden'}
                borderRadius={'28px'}
                ratio={258 / 245}>
                <Image src={item.image} objectFit={'cover'} width={'100%'} height={'100%'} />
              </AspectRatio>
              <Flex width={'100%'} pt={{ base: '10px', md: '34px' }} lineHeight={1.375} flexDir={'column'}>
                <Text fontSize={24} fontWeight={600}>
                  {item.title}
                </Text>
                <Text
                  fontSize={16}
                  mt={'auto'}
                  overflowY={'scroll'}
                  sx={{
                    '::-webkit-scrollbar': { display: 'none' },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none'
                  }}>
                  {item.content}
                </Text>
              </Flex>
            </Flex>
          </Link>
        ))}
      </Flex>
    </Box>
  );
};

export default NewHomeNews;
